import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { overlayBunja, useOverlayItem } from '@flipster/overlay';

export function useSingleMovableModal(isOpen: boolean, onClose: (() => void) | undefined) {
  const { presenceItemsAtom } = useBunja(overlayBunja);
  const items = useAtomValue(presenceItemsAtom);
  const { id: myId } = useOverlayItem();
  const myItem = items.find((item) => item.id === myId);
  const sameSlotItems = myItem ? items.filter((item) => item.slot === myItem.slot) : items;
  const isLatest = sameSlotItems.at(-1)?.id === myId;

  useEffect(() => {
    if (isOpen && !isLatest) {
      onClose?.();
    }
  }, [isOpen, isLatest, onClose]);
}

export function useCloseOnRouteChange(onClose: (() => void) | undefined) {
  const pathname = usePathname();
  const initialPathnameRef = useRef(pathname);

  useEffect(() => {
    if (pathname !== initialPathnameRef.current) {
      onClose?.();
    }
  }, [pathname, onClose]);
}
